import { Component, OnInit, ViewChild,ElementRef, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import {MatTableDataSource, MatPaginator } from '@angular/material';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';

import { AppSettings } from '../../../app.constant';
import { DataSource } from '@angular/cdk/table';
import { Program } from 'src/app/shared/class/program';
import { ProgramService } from 'src/app/shared/services/program.service';
import { ModuleService } from 'src/app/shared/services/module.service';
import { BatchService } from 'src/app/shared/services/batch.service';
import { StudentsService } from 'src/app/shared/services/students.service';
import { ExaminationService } from 'src/app/shared/services/examination.service';

import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-transcript-table',
  templateUrl: './transcript-table.component.html',
  styleUrls: ['./transcript-table.component.css'],
  animations: [
    trigger('popOverState', [
      state('show', style({
        opacity: 1,
      })),
      state('hide',   style({
        opacity: 0,
        display:'none'
      })),
      transition('show => hide', animate('600ms ease-out')),
      transition('hide => show', animate('1000ms ease-in'))
    ]),

    trigger('popOverTable', [
      state('hide', style({
        opacity: 0,
        display:'none'
      })),
      state('show',   style({
        opacity: 1
      })),
      transition('hide => show', animate('600ms ease-out')),
      transition('show => hide', animate('1000ms ease-in'))
    ])
  ]
})
export class TranscriptTableComponent implements OnInit {

  displayedColumns: string[] =  ['EnrolmentNo','FirstName','ProgramCode','SubjectCode','SubjectName','ExamSection','CA','Exam','Total','Grade'];
  post:any;
  public resultdata:any;
  public resultdata1:any;
  programs:any;
  dataSource;
  students:any;
  message:any;
  errorMessage: String;
  modules:any;
  show = false;
  tableShow = false;
  batches:any;
  PK_ProgramID:any;
  PK_BatchID:any;
  examForm:FormGroup; 
  progressBar:boolean = true;
  selectedProgram:Program = new Program (0,'ABC','asd','sadasdsa');
  FK_ProgramID:any=null;
  FK_ModuleID:any=null;
  FK_BatchID:any=null;
  EnrollmentNo:any=null;
  FK_StudentID:any=null;
  ExamEntities:any=null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('content') content: ElementRef;
  @Output() messageEvent = new EventEmitter<string>();

  constructor(
      private formbuilder:FormBuilder,
      private _programservice:ProgramService,
      private _moduleservice:ModuleService,
      private _batchservice:BatchService,
      private _examinationservice:ExaminationService, 
      private _studentservice:StudentsService,
      private changeDetectorRefs: ChangeDetectorRef) { }

  ngOnInit() {
    this.examForm = this.formbuilder.group({
      'FK_ProgramID':[''],
      'FK_ModuleID':[''],
      'FK_BatchID':[''],
      'EnrollmentNo':[''],
      'FK_StudentID':[],
      'ExamEntities' : this.formbuilder.array([])
    })

    // this.getModuleByProgramID(this.selectedProgram.PK_ProgramID);
          this.getAllProgram();

    // this._examinationservice.refreshNeeded$
    //       .subscribe(()=>{
    //       this.getAllExam();
    // })

    //  this.getAllExam();
     this._examinationservice.currentMessage.subscribe(message=>this.message=message)
  }


  get stateName() {
    return this.show ? 'show' : 'hide'
  }


  get tableToggleName(){
    return this.tableShow ? 'hide':'show'
  }

  close(){
    this.tableShow = !this.tableShow;
    this.show =!this.show;
 }

  
getAllProgram() :void  {
      this._programservice.getAllProgram(AppSettings.API_ENDPOINT+AppSettings.GetAllProgram).subscribe(
      data => {
        this.programs=data;
      },
    error => this.errorMessage = <any>error)
}

getModuleByProgramID(PK_ProgramID) :void  {
      this.PK_ProgramID=PK_ProgramID;
      var o={
        PK_ProgramID:PK_ProgramID}
        this.post=JSON.stringify(o);
        this.getBatchByProgramID(PK_ProgramID);
        this._moduleservice.getModuleByProgramID(AppSettings.API_ENDPOINT+AppSettings.GetModuleByProgramID,this.post).subscribe(
          data => {
        this.modules=data;
        //this.modules= this.module.filter((item) => item.FK_ProgramID == PK_ProgramID);
      },
    error => this.errorMessage = <any>error)
}

getBatchByProgramID(PK_ProgramID) :void  {
     var o={
            PK_ProgramID:PK_ProgramID}
            this.post=JSON.stringify(o);
            this._batchservice.GetBatchByProgramID(AppSettings.API_ENDPOINT+AppSettings.GetBatchByProgramID, this.post).subscribe(
            data => {
            this.batches=data;
            // this.batches= this.batch.filter((item) => item.FK_ProgramID == PK_ProgramID);
            },
            error => this.errorMessage = <any>error)
 }


getStudentsByBatchID(PK_BatchID) :void {
    this.PK_BatchID=PK_BatchID;
    var o={
    PK_BatchID:PK_BatchID}
    this.post=JSON.stringify(o);
    this._studentservice.getStudentsByBatchID(AppSettings.API_ENDPOINT+AppSettings.GetStudentsByBatchID, this.post).subscribe(
        data => {
    this.students=data;
    // this.students= this.student.filter((item) => item.FK_ProgramID == PK_ProgramID);
   },
    error => this.errorMessage = <any>error)
  }

  public GetResultList(exams) {
    this._examinationservice.changeMessage(this.EnrollmentNo);
    this.show = !this.show;
    this.tableShow = !this.tableShow;
  

    // var o={
    //         EnrolmentNo:this.EnrollmentNo,
    //         FK_ModuleID:this.FK_ModuleID,
    //         PK_ProgramID:this.PK_ProgramID,
    //         PK_BatchID:this.PK_BatchID,
    //                           } 
    //   this.post=JSON.stringify(o);
   
    //   this._examinationservice.getResultByEnrollmentNo(AppSettings.API_ENDPOINT+AppSettings.GetExamByEnrollmentNo,this.post)
    // .subscribe(result =>{
    //   this.resultdata1=result;
     
    //   console.table( this.resultdata1);
    //   });
  }

getEnrollmentNo(EnrollmentNo)    {
      this.EnrollmentNo=EnrollmentNo;
      alert(EnrollmentNo);
  }

getAllExam(EnrollmentNo) {
    var o={
          EnrolmentNo:this.EnrollmentNo,
          FK_ModuleID:this.FK_ModuleID,
          PK_ProgramID:this.PK_ProgramID,
          PK_BatchID:this.PK_BatchID,
          }

    this.post=JSON.stringify(o);
    this._examinationservice.getResultByEnrollmentNo(AppSettings.API_ENDPOINT+AppSettings.GetExamByEnrollmentNo,this.post)
          .subscribe(result =>{
          this.resultdata=result;
          this.progressBar = false;
          this.changeDetectorRefs.detectChanges();
          if(!result){
            return;
            }
          this.stateName;
    this.dataSource = new MatTableDataSource(this.resultdata);
    this.dataSource.paginator = this.paginator;
  });
 }



//  getAllExam() {
//   var o={
//         EnrolmentNo:this.EnrollmentNo,
//         FK_ModuleID:this.FK_ModuleID,
//         FK_ProgramID:this.PK_ProgramID,
//         PK_BatchID:this.PK_BatchID,
//         }
//   this.post=JSON.stringify(o);

//   this._examinationservice.getAllTempExam(AppSettings.API_ENDPOINT+AppSettings.GetAllExams)
//   .subscribe(result =>{
//     this.resultdata=result;
//     this.progressBar = false;
//     this.changeDetectorRefs.detectChanges();
//     if(!result){
//       return;
//   }
//   this.dataSource = new MatTableDataSource(this.resultdata);
//   this.dataSource.paginator = this.paginator;
// });
// }


}


